import { Link } from 'react-router-dom';
import AdSlot from '../AdSlot';

const faqs = [
  {
    q: 'Is HD Video Download free to use?',
    a: 'Yes, completely free. You can download unlimited videos without any registration or payment.',
  },
  {
    q: 'What video quality options are available?',
    a: 'We support qualities from 240p up to 4K (2160p), depending on what the original video offers. You can also download audio-only in MP3 format.',
  },
  {
    q: 'Do I need to install any software?',
    a: 'No. HD Video Download works entirely in your browser. No software, extensions, or apps needed.',
  },
  {
    q: 'Which platforms are supported?',
    a: 'We support YouTube, Twitter (X), Instagram, TikTok, and Facebook. More platforms will be added in the future.',
  },
  {
    q: 'Can I download private videos?',
    a: 'No. Only publicly available videos can be downloaded. Private or restricted content is not accessible.',
  },
  {
    q: 'Why is my YouTube download taking long?',
    a: 'YouTube videos require extra processing on our servers. Most videos are ready within 1-2 minutes. Higher quality videos may take longer.',
  },
  {
    q: 'Is it legal to download videos?',
    a: 'Downloading videos for personal use is generally acceptable. However, redistributing copyrighted content without permission is illegal. Always respect content creators\' rights.',
  },
  {
    q: 'Does it work on mobile devices?',
    a: 'Yes! Our tool works on any device with a web browser — iPhone, Android, iPad, and desktop computers.',
  },
  {
    q: 'Why do some videos fail to download?',
    a: 'Some videos may be region-restricted, age-restricted, or private. In these cases, downloading is not possible. Try a different video or check if the URL is correct.',
  },
  {
    q: 'What format should I choose?',
    a: 'MP4 is the most compatible video format — it works on all devices. Choose MP3 if you only need the audio (great for music). For quality, 720p HD offers the best balance between quality and file size.',
  },
  {
    q: 'Does HD Video Download support adult content?',
    a: 'No. HD Video Download is strictly a tool for downloading publicly available videos from mainstream social media platforms (YouTube, Twitter, Instagram, TikTok, Facebook). We do not support, allow, or facilitate downloading of adult, explicit, or age-restricted content. Any attempt to download such content is not supported by our service.',
  },
  {
    q: 'What is your content policy?',
    a: 'We only support downloading publicly available videos from mainstream platforms for personal, non-commercial use. Users are responsible for complying with applicable laws and the terms of service of the source platform. Downloading copyrighted content for redistribution is prohibited.',
  },
];

function FAQ() {
  return (
    <div className="app">
      <AdSlot slot="XXXXXXXXXX" format="horizontal" className="ad-top" />

      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>

        <h1 className="page-title">Frequently Asked Questions</h1>
        <p className="page-subtitle">Everything you need to know about downloading videos with HD Video Download.</p>

        <div className="faq-list">
          {faqs.map((faq, i) => (
            <details key={i} className="faq-item">
              <summary className="faq-question">{faq.q}</summary>
              <p className="faq-answer">{faq.a}</p>
            </details>
          ))}
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Start Downloading Now</Link>
        </div>
      </div>

      <AdSlot slot="XXXXXXXXXX" format="horizontal" className="ad-bottom" />

      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default FAQ;
